import { Shield } from "lucide-react";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="pb-24">
      <section className="pt-16 lg:pt-24 pb-12">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <div className="flex items-center gap-3 mb-5">
            <Shield className="w-6 h-6 text-[#E2718A]" />
            <div className="text-sm uppercase tracking-[0.2em] text-[#EA823A] font-semibold">Privacy Policy</div>
          </div>
          <h1 className="font-display text-5xl text-[#1F2A2E] leading-tight mb-4">Your privacy, protected.</h1>
          <p className="text-[#6B7A80]">Last updated: January 2026</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 lg:px-8 prose prose-lg text-[#284952] leading-relaxed space-y-7">
        <Block title="Who we are">
          Navica Supports Pty Ltd is an AASW-accredited social work practice and NDIS support coordination service based in Sydney, Australia. We collect and handle personal information in accordance with the Australian Privacy Principles (APPs) under the Privacy Act 1988 (Cth).
        </Block>
        <Block title="What we collect">
          We collect only the information necessary to provide our services. This includes name, contact details, NDIS number and plan details, demographic information, primary disability, and reason for referral. Sensitive information is collected only with your consent.
        </Block>
        <Block title="How we use it">
          We use your information solely to deliver agreed services, coordinate with providers on your behalf (with your permission), maintain records required under NDIS and AASW standards, and communicate with you about your supports.
        </Block>
        <Block title="How we protect it">
          All data is stored in secure systems with encryption in transit and at rest. Access is restricted to authorised personnel only. We follow the AASW Code of Ethics on confidentiality.
        </Block>
        <Block title="Your rights">
          You may request access to or correction of your personal information at any time. You may also withdraw consent for ongoing use. To make a request, email info@navicasupports.com.
        </Block>
        <Block title="Contact">
          For any privacy questions or concerns, contact us at info@navicasupports.com or 1300 105 034.
        </Block>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl text-[#1F2A2E] mb-3">{title}</h2>
      <p className="text-lg leading-relaxed">{children}</p>
    </div>
  );
}
